var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122779",
    "data-name": "Group 122779",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#91238d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-minus",
    "data-name": "Icon feather-file-minus",
    transform: "translate(307.005 250.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20313",
    "data-name": "Path 20313",
    d: "M13.493,3H7.5A1.5,1.5,0,0,0,6,4.5V16.488a1.5,1.5,0,0,0,1.5,1.5h8.992a1.5,1.5,0,0,0,1.5-1.5V7.5Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20314",
    "data-name": "Path 20314",
    d: "M21,3V7.5h4.5",
    transform: "translate(-7.507)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20315",
    "data-name": "Path 20315",
    d: "M13.5,22.5H18",
    transform: "translate(-3.753 -9.759)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.36e612b079f25a0cf836d4a124ceb954.svg";
export { ForwardRef as ReactComponent };